import { heroStats } from "@/mocks/comicData";

export default function Hero() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative flex min-h-[92vh] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20manga%20collage%20artwork%20with%20bold%20warm%20orange%20and%20amber%20tones%2C%20dynamic%20anime%20character%20silhouettes%20reading%20comics%2C%20floating%20abstract%20comic%20panels%20and%20speech%20bubbles%2C%20soft%20cream%20gradient%20background%2C%20high%20energy%20youthful%20illustration%2C%20editorial%20magazine%20cover%20style&width=1600&height=900&seq=comic-hero-01&orientation=landscape"
          alt="漫画阅读推荐主题插画"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/50 via-background-950/40 to-background-950/70"></div>
      </div>

      <div className="section-x relative z-10 w-full py-24 md:py-32">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 ring-1 ring-background-50/30 backdrop-blur-sm">
            <i className="ri-fire-line text-primary-300"></i>
            正版漫画阅读 · 一站找全
          </span>

          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            漫画阅读软件推荐指南
            <span className="mt-2 block text-primary-300">轻松追更，不迷路</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            精选正版国漫、日漫、韩漫、美漫阅读平台，高清画质、更新及时、离线可读。
            无论你是新手入坑还是老书虫补番，都能在这里快速锁定适合自己的漫画阅读软件。
          </p>

          <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
            <button
              type="button"
              onClick={() => go("#ranking")}
              className="w-full cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-base font-medium text-background-50 transition-colors hover:bg-primary-400 sm:w-auto"
            >
              查看热门榜单
            </button>
            <button
              type="button"
              onClick={() => go("#guide")}
              className="w-full cursor-pointer whitespace-nowrap rounded-full bg-background-50/10 px-8 py-3.5 text-base font-medium text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              浏览阅读攻略
            </button>
          </div>
        </div>

        <div className="mx-auto mt-14 grid w-full max-w-4xl grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/10 px-4 py-4 text-center ring-1 ring-background-50/20 backdrop-blur-sm"
            >
              <p className="font-heading text-3xl text-primary-200 md:text-4xl">
                {s.value}
                <span className="text-xl">{s.unit}</span>
              </p>
              <p className="mt-1 text-sm text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}